<template>
  <div style="height: 100%">

    <el-card class="box-card BomRouteContext-card" :body-style="{padding:'4px'}" style="display: flex;flex-direction: column;height: 100%;">
      <!-- <div slot="header" class="clearfix" style="text-align:center;font-size:larger;font-weight:bold;">
        <span>BOM及工艺核对表</span>
      </div> -->
      <div slot="header" style="padding: 0;">
        <b-row style="padding: 4px; ">
        <b-col sm="auto" style="padding-top: 6px; padding-right: 2px">
          <i class="iconfont icon-search"></i>
        </b-col>
        <b-col sm="auto" class="pl-1">
          销售公司：
          <el-select size="small" class="mr-1" v-model="dataAreaId" @change="CompanyChanged(dataAreaId)" filterable clearable
            placeholder="请选择销售公司" style="width:200px">
            <el-option v-for="(t,k) in $store.state.biz_data.baseData.CompanyInfo" :key="k" :label="t.DataArea+':'+t.CompanyName"
              :value="t.DataArea"></el-option>
          </el-select>
          物料：
          <el-select size="small" class="mr-1" v-model="InventNum" filterable remote reserve-keyword :remote-method="ItemIdRemoteMethod"
            clearable @clear="ItemIdRemoteMethod('')" placeholder="请输入物料关键词" style="width: 300px">
            <el-option v-for="(t,k) in InventOptions" :key="k" :label="t.label" :value="t.value"></el-option>
          </el-select>
          产成品数量：
          <el-input placeholder="请输入产成品数量" v-model="ProductQty" style="width:200px" clearable @input="onInput()"></el-input>
        </b-col>
        <b-col class="pl-1">
          <QueryButton @on_query="on_query" :label="$t('common.query')"></QueryButton>
          <QueryButton @on_query="on_export" :label="$t('common.export')" :type="''" :iconClass="'iconfont icon-print'"></QueryButton>
          <!-- <QueryButton @on_query="on_print" :label="$t('common.print')" :type="''" :iconClass="'iconfont icon-print'"></QueryButton> -->
        </b-col>
      </b-row>
      </div>
      <div style="height:100%;overflow-y: auto;border:1px solid grey ;">
        <div name="BomRouteContext" v-show="showContext"></div>
        <el-empty :image-size="200" v-show="!showContext"></el-empty>
      </div>
    </el-card>
  </div>
</template>
<script>
import QueryButton from "../components/base/QueryButton.vue";
import * as InventTableController from "../../controllers/base/InventTableController";
import * as CostItemsController from "../../controllers/sd/CostItemsController";


export default {
  components: {
    QueryButton
  },
  data() {
    return {
      dataAreaId: "",
      InventNum: "",
      showContext: false,
      InventOptions: [],
      cur_dataAreaId: "",
      ProductQty: ""
    }
  },

  methods: {
    async on_query(set_data) {
      set_data([]);
      if (this.ProductQty == "") {
        this.msgToasts("请输入产成品数量！", "info");
        return;
      }
      const loading = this.$loading({
        lock: true,
        text: this.$t("notify.loading"),
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      let _template_content = _.find(this.$store.state.biz_data.templateData.templates, { notify_type: "bom_and_route_check" });
      if (_template_content) {
        let content_data = await this.setDataSources();
        if (content_data) {
          var fn = template.compile(_template_content.content);
          let temp_html = "";
          temp_html = fn(content_data);
          document.getElementsByName("BomRouteContext")[0].innerHTML = temp_html;
          this.showContext = true
        }
        else
          this.showContext = false;
      }
      loading.close();
    },
    async setDataSources() {
      let _rt1 = await CostItemsController.methods.getBomRouteCheck({ ItemId: this.InventNum, dataAreaId: this.dataAreaId, productQty: this.ProductQty });
      let m = _.find(_rt1[0], { dataAreaId: this.dataAreaId });
      if (!m) return;
      let _rt2 = await CostItemsController.methods.execCalcBomCost(
        { ItemId: this.InventNum, ProductQty: this.ProductQty, AccountNum: null, dataAreaId: this.dataAreaId, BomID: m.BomId, RouteID: m.RouteId });
      let _rt3 = await CostItemsController.methods.execCalcRsrcCost(
        { ItemId: this.InventNum, ProductQty: this.ProductQty, AccountNum: null, dataAreaId: this.dataAreaId, BomID: m.BOMId, RouteID: m.RouteId });
      // console.log(_rt1)
      // console.log(_rt2)
      // console.log(_rt3)
      let content_data = {};
      //基本信息
      if (_rt1 && _rt1.length > 0) {
        //基本信息
        let dt1_m = _rt1[0][0];
        if (!dt1_m) {
          return null;
        }
        content_data.product = {
          product_num: dt1_m.product_num,
          product_name: dt1_m.product_name,
          box_type: dt1_m.box_type,
          routeId: dt1_m.RouteId,
          routeName: dt1_m.RouteName,
          routeApprover: dt1_m.RouteApprover,
          bomId: dt1_m.BomId,
          bomName: dt1_m.BomName,
          bomApprover: dt1_m.BomApprover,
          product_size: dt1_m.product_size,
          product_cqty: "",//联数
          product_qty: dt1_m.product_qty,
          product_parts: "",
          route_process: [],//工艺流程
          product_print: "",//印前要求
          product_pack: ""
        };
        //部件构成
        let dt2 = _rt1[1];
        if (dt2 && dt2.length > 0) {
          let parts = []
          _.each(dt2, (t) => {
            let _pt = t.ProductPartsType;
            if (_pt && _pt != "") {
              let pt_items = _pt.split(",")
              for (var i in pt_items) {
                let base_pt_m = _.find(this.$store.state.biz_data.baseData.ProductPartsType, { id: parseInt(pt_items[i]) });
                if (base_pt_m && !_.includes(parts, base_pt_m.text)) {
                  parts.push(base_pt_m.text)
                }
              }
            }
          })
          content_data.product.product_parts = _.join(parts, "+")
        }
        //工艺流程
        let dt3 = _rt1[2], _route_process = [];
        if (dt3 && dt3.length > 0) {
          let group_parts = _.groupBy(dt3, "TEC_ProductParts");
          for (var k in group_parts) {
            let parts_items = _.orderBy(group_parts[k], ["OprNum"], ["asc"]), parts_item_child = [];
            console.log(parts_items)
            for (var ct in parts_items) {
              if (parts_item_child.length == 0) {
                parts_item_child.push(parts_items[ct].OprId)
              }
              let m = _.find(parts_items, { OprNum: parts_items[ct].OprNumNext });
              if (m) {
                parts_item_child.push(m.OprId)
              }
            }
            // parts_item_child = _.uniq(parts_item_child);
            _route_process.push(k + ":" + _.join(parts_item_child, "->"))
          }
          content_data.product.route_process = _route_process;
          //包装要求
          let _product_pack = _.map(_.filter(dt3, (dm) => { return dm.TEC_QualityRequirement != "" && dm.TEC_QualityRequirement }),
            (t) => { return t.TEC_QualityRequirement });
          if (_product_pack && _product_pack.length > 0)
            content_data.product.product_pack = _.join(_product_pack, "；")
          //印前要求
          let print_before_data = _.filter(dt3, { RouteType: "CTP" });
          let pbd = _.map(print_before_data, (t) => {
            return t.TEC_RouteRequirement;
          })
          content_data.product.product_print = _.join(pbd, "；")
          //工序资源
          content_data.route_resources = [];
          let rrdt = []
          _.each(dt3, (t) => {
            let parts = [];
            if (t.ProductPartsType && t.ProductPartsType != "") {
              let pt_items = t.ProductPartsType.split(",")
              for (var i in pt_items) {
                let base_pt_m = _.find(this.$store.state.biz_data.baseData.ProductPartsType, { id: parseInt(pt_items[i]) });
                if (base_pt_m)
                  parts.push(base_pt_m.text);
              }
            }
            t.ProductPartsType = _.join(parts, "/");
            rrdt.push(t)
          })

          content_data.route_resources = _.orderBy(_.uniqBy(rrdt, "OprNum"), ["OprNum"], ["asc"]);
        }
      }
      //工序及工序资源
      content_data.route = [];
      if (_rt3 && _rt3[0].length > 0) {
        let _route = _.cloneDeep(_.filter(_rt3[0], { RouteId: content_data.product.routeId }));
        let rdt = []
        _.each(_rt1[3], (t) => {
          let m = _.find(_route, { OprNum: t.OprNum });
          if (m) {
            if (t.ProductPartsType && t.ProductPartsType != "")
              m.ProductPartsType = t.ProductPartsType;
            rdt.push(m);
          }
        })

        content_data.route = _.orderBy(_.uniqBy(rdt), ["OprNum"], ["asc"]);
      }
      //用料
      content_data.materials = [];
      if (_rt2 && _rt2[0].length > 0) {
        let _materials = _.filter(_rt2[0], { BOMId: content_data.product.bomId });
        _.each(_materials, (t) => {
          let parts = [];
          if (t.ProductPartsType && t.ProductPartsType != "") {
            let pt_items = t.ProductPartsType.split(",")
            for (var i in pt_items) {
              let base_pt_m = _.find(this.$store.state.biz_data.baseData.ProductPartsType, { id: parseInt(pt_items[i]) });
              if (base_pt_m)
                parts.push(base_pt_m.text);
            }
          }
          t.ProductPartsTypeView = _.join(parts, "/");
          t.RouteJustQty = t.RouteJustQty * t.BOMQty / t.BOMQtySerie;
          t.Loss = (t.SpoilageQty + t.AddQty) * t.BOMQty / t.BOMQtySerie;
          // let mmdt = _.filter(_rt3[0], { ItemId: t.DetailItemId });
          // if (mmdt.length > 0) {
          //   t.RouteJustQty = mmdt[0].RouteJustQty * t.BOMQty / t.BOMQtySerie;
          //   t.Loss = (mmdt[0].SpoilageQty + mmdt[0].AddQty) * t.BOMQty / t.BOMQtySerie;
          // }
          if (t.TEC_SpoilageType) {
            let spoilage_type_m = _.find(this.$store.state.biz_data.baseData.SpoilageTypeRatio, { SpoilageType: t.TEC_SpoilageType });
            if (spoilage_type_m) {
              t.Loss = t.Loss * spoilage_type_m.Ratio;
              let dec = 2;
              let unit_m = _.find(this.$store.state.biz_data.baseData.UnitOfMeasure, { Symbol: t.DW_InventUnitId });
              if (unit_m)
                dec = unit_m.DecimalPrecision;
              switch (spoilage_type_m.carryType) {
                case "进一":
                  t.real_qty = _.ceil(t.real_qty, dec);
                  t.RouteJustQty = _.ceil(t.RouteJustQty, dec);
                  t.Loss = _.ceil(t.Loss, dec);
                  break;
                case "四舍五入":
                  t.real_qty = _.round(t.real_qty, dec);
                  t.RouteJustQty = _.round(t.RouteJustQty, dec);
                  t.Loss = _.round(t.Loss, dec);
                  break;
                default:
                  t.real_qty = _.round(t.real_qty, dec);
                  t.RouteJustQty = _.round(t.RouteJustQty, dec);
                  t.Loss = _.round(t.Loss, dec);
                  break;
              }
            }
          }
        })
        content_data.materials = _.orderBy(_materials, ["LineNum"], ["asc"]);
      }
      // console.log(content_data)
      return content_data;
    },
    async CompanyChanged(theDataAreaId) {
      this.cur_dataAreaId = theDataAreaId;
      await this.getKvInvent(theDataAreaId);
    },
    ///根据dataAreaId获取物料
    async getKvInvent(_dataAreaId, query = '') {
      let p = {};
      p.dataAreaId = _dataAreaId;
      p.Query = query;
      // _p.publicItem = 2;
      let _result = await InventTableController.methods.getTop100InventKvData(p);
      if (!_.isNull(_result) && _result && _result.length > 0) {
        this.InventOptions = _.map(_result[0], (t) => {
          return { value: t.ItemId, label: t.ItemId + ":" + t.NameAlias };
        });
      }
    },
    ///物料下拉
    async ItemIdRemoteMethod(query) {
      await this.getKvInvent(this.cur_dataAreaId, query);
    },
    onInput() {
      if (this.ProductQty != "") {
        this.ProductQty = parseInt(this.ProductQty.replace(/[^\d]/g, ""));
      }
    },
    //导出
    on_export(cb) {
      var excelContent = document.getElementsByName("BomRouteContext")[0].innerHTML;
      if (excelContent == "") {
        cb(null)
        return
      }
      var excelFile = "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:x='urn:schemas-microsoft-com:office:excel' xmlns='http://www.w3.org/TR/REC-html40'>";
      excelFile += "<head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head>";
      excelFile += "<body>";
      excelFile += excelContent;
      excelFile += "</body>";
      excelFile += "</html>";
      var link = "data:application/vnd.ms-excel;base64," + window.btoa(unescape(encodeURIComponent(excelFile)));
      var a = document.createElement("a");
      a.download = "BOM及工艺核对表(" + this.dataAreaId + "：" + this.InventNum + ").xls";
      a.href = link;
      a.click();
      cb(null)
    },
    //打印
    on_print(cb) {
      var excelContent = document.getElementsByName("BomRouteContext")[0].innerHTML;
      if (excelContent == "") {
        cb(null)
        return
      }

      var BomRouteContextHtml = document.getElementsByName("BomRouteContext")[0].innerHTML;
      let print_window = window.open("", "打印");
      let style = document.createElement('style')
      style.innerHTML = "@page{size:landscape;margin:auto 0mm;}"
      print_window.document.head.appendChild(style)
      print_window.document.body.innerHTML = BomRouteContextHtml;
      print_window.print();
      print_window.location.reload();

      cb(null)
    }
  }
}
</script>
<style scoped>
.BomRouteContext-card :deep(.el-card__body){
  flex: 1;
}
</style>
